module.exports = __webpack_public_path__ + "static/media/snellen.4199412e.jpg";